<h2 mat-dialog-title>Fecha del reporte de ingresos</h2>
<mat-dialog-content>
  <form [formGroup]="registerForm" (ngSubmit)="generarReporte()" class="example-form">
<br>

    <mat-form-field appearance="outline" 
    class="example-full-width"
    style="padding-left: 10px; font-size: smaller">
      <mat-label>Fecha </mat-label>
      <input matInput [matDatepicker]="picker" formControlName="fecha" placeholder="Fecha de generación del reporte">

      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="generarReporte()"
    [disabled]="registerForm.invalid"
  >
    Descargar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>
